import { useDispatch } from 'react-redux';
import {
  applyCartItemQuantityOverride,
  clearCartItemQuantityOverride,
  settleCartItemQuantityOverride,
} from '~/redux/reducers/cart';

/**
 * The optimistic side of a cart quantity edit. An edit is recorded alongside the
 * server carts rather than in them, so both cart surfaces show it from one
 * place, the server value stays available to fall back on, and a cart refetch
 * landing mid-edit can't drop it. Read the merged result through
 * `useQuantityOverrides`.
 *
 * `settleQuantityOverride` hands the item back to server data once its save
 * lands; `clearQuantityOverride` drops the edit, which is what rolls a rejected
 * save back.
 */
export function useOptimisticCartQuantity() {
  const dispatch = useDispatch();

  return {
    applyQuantityOverride(
      cartId: string,
      productId: string,
      value: number,
      piecesCount?: number
    ) {
      dispatch(
        applyCartItemQuantityOverride({ cartId, productId, value, piecesCount })
      );
    },

    settleQuantityOverride(cartId: string, productId: string) {
      dispatch(settleCartItemQuantityOverride({ cartId, productId }));
    },

    clearQuantityOverride(cartId: string, productId: string) {
      dispatch(clearCartItemQuantityOverride({ cartId, productId }));
    },
  };
}
